import { createContext, useContext, useEffect, useState } from 'react';

import { MarketplaceLead } from '~/types/marketplace';

type LeadContextType = {
  lead: MarketplaceLead | null;
  setLead: (lead: MarketplaceLead | null) => void;
};

export const LeadContext = createContext<LeadContextType>({
  lead: null,
  setLead: () => {},
});

export const LeadProvider = ({
  lead: initialLead,
  children,
}: {
  lead: MarketplaceLead | null;
  children: React.ReactNode;
}) => {
  const [lead, setLead] = useState<MarketplaceLead | null>(initialLead);

  useEffect(() => {
    setLead(initialLead);
  }, [initialLead]);

  return <LeadContext.Provider value={{ lead, setLead }}>{children}</LeadContext.Provider>;
};

export const useLeadContext = () => {
  const context = useContext(LeadContext);
  if (context === undefined) {
    throw new Error('useLeadContext must be used within a LeadProvider');
  }
  return context;
};
